import { render } from "./ViewsAuthLoginSso.vue?vue&type=template&id=bfd272d8"
import script from "./ViewsAuthLoginSso.vue?vue&type=script&lang=js"
export * from "./ViewsAuthLoginSso.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__